export const Field = ({ id, label, error, hint, required, children }) => (
  <div className="space-y-2">
    <label htmlFor={id} className="block text-sm text-zinc-300">
      {label}{required && <span className="text-[#0055FF] ml-1" aria-hidden>*</span>}
    </label>
    {children}
    {hint && !error && <p className="text-xs text-zinc-600">{hint}</p>}
    {error && <p id={`${id}-error`} className="text-xs text-[#FF3B30]" role="alert" data-testid={`error-${id}`}>{error}</p>}
  </div>
);

export const TextInput = ({ id, form, set, errors, type = "text", ...rest }) => (
  <input
    id={id} name={id} type={type} value={form[id]} onChange={(e) => set(id, e.target.value)}
    aria-invalid={!!errors[id]} aria-describedby={errors[id] ? `${id}-error` : undefined}
    className={`eb-input ${errors[id] ? "!border-[#FF3B30]" : ""}`} data-testid={`enquiry-${id}`} {...rest}
  />
);

export const TextArea = ({ id, form, set, errors, rows = 4, ...rest }) => (
  <textarea
    id={id} name={id} rows={rows} value={form[id]} onChange={(e) => set(id, e.target.value)}
    aria-invalid={!!errors[id]} aria-describedby={errors[id] ? `${id}-error` : undefined}
    className={`eb-input resize-y ${errors[id] ? "!border-[#FF3B30]" : ""}`} data-testid={`enquiry-${id}`} {...rest}
  />
);

export const Choice = ({ id, form, set, errors, options, placeholder = "Select" }) => (
  <select
    id={id} name={id} value={form[id]} onChange={(e) => set(id, e.target.value)} aria-invalid={!!errors[id]}
    className={`eb-input appearance-none ${errors[id] ? "!border-[#FF3B30]" : ""}`} data-testid={`enquiry-${id}`}
  >
    <option value="">{placeholder}</option>
    {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
  </select>
);
